import { layout } from '../../../tokens/tokens-base/properties/build/js/index.js';
const media = {
  xsMin: '(min-width: 0px)',
  xsMax: `(max-width: ${layout.xs.breakpoint.max})`,
  xsMinMax: `(min-width: 0px) and (max-width: ${layout.xs.breakpoint.max})`,
  smMin: `(min-width: ${layout.sm.breakpoint.min})`,
  smMax: `(max-width: ${layout.sm.breakpoint.max})`,
  smMinMax: `(min-width: ${layout.sm.breakpoint.min}) and (max-width: ${layout.sm.breakpoint.max})`,
  mdMin: `(min-width: ${layout.md.breakpoint.min})`,
  mdMax: `(max-width: ${layout.md.breakpoint.max})`,
  mdMinMax: `(min-width: ${layout.md.breakpoint.min}) and (max-width: ${layout.md.breakpoint.max})`,
  lgMin: `(min-width: ${layout.lg.breakpoint.min})`,
  lgMax: `(max-width: ${layout.lg.breakpoint.max})`,
  lgMinMax: `(min-width: ${layout.lg.breakpoint.min}) and (max-width: ${layout.lg.breakpoint.max})`,
  xlMin: `(min-width: ${layout.xl.breakpoint.min})`,
  xlMax: `(max-width: ${layout.xl.breakpoint.max})`,
  xlMinMax: `(min-width: ${layout.xl.breakpoint.min}) and (max-width: ${layout.xl.breakpoint.max})`,
  xxlMin: `(min-width: ${layout.xxl.breakpoint.min})`
};
export { media };